<template>
  <div class="Manifest">
    <template>
      <div class="articles-lists">
        <div>
          <number-section v-for="(item, key) in dataTemp" :title="item.name" :editable="editable" :data="item.children" :id="item.id" :key="key" />
        </div>
      </div>
    </template>

    <div class="Manifest__buttons">
      <el-button v-if="!editable" @click="edit" style="float:left;">编辑清单</el-button>
      <div style="float:right;">
        <el-button @click="emitClose">取 消</el-button>
        <el-button type="primary" @click="handleClick">确 定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import NumberSection from './NumberSection'

export default {
  props: {
    isEntireRent: {
      type: Boolean,
    },
    data: {
      type: Array,
      required: true,
    },
    useXHR: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    NumberSection,
  },

  mounted () {
    console.log(this.useXHR)
  },

  data () {
    return {
      editable: false,
      dataTemp: JSON.parse(JSON.stringify(this.data)),
    }
  },

  watch: {
    dataTemp: {
      immediate: true,
      handler: val => console.log('watch 0', val),
    },
  },

  methods: {
    edit () {
      this.editable = true
    },
    emitClose () {
      this.$emit('close')
    },

    submit () {
      const data = this.dataTemp
      this.$emit('update:data', data)
      this.$emit('submit', data)
      this.emitClose()
    },

    save () {
      const data = this.dataTemp
      this.$emit('update:data', data)
      this.$emit('save', data)
    },

    handleClick () {
      if (this.useXHR) {
        this.save()
      } else {
        this.submit()
      }
    },
  },
}
</script>

<style lang="scss">
.Manifest__buttons {
  padding: 24px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/ReletContractForm/Manifest.vue